import React from 'react';
import './ThankYouScreen.css';

const ThankYouScreen = ({ participationType }) => {
  const isParticipating = participationType === 'yes' || participationType === 'listen';
  
  return (
    <div className="thankyou-screen">
      <div className="thankyou-container">
        <div className="success-icon">
          ✓
        </div>
        <h1>ご回答ありがとうございました</h1>
        {isParticipating ? (
          <p>
            ご協力いただき、誠にありがとうございます。<br />
            3日以内にご連絡いたします。
          </p>
        ) : (
          <p>
            実証実験に関するお返事をいただき、<br />
            誠にありがとうございます。
          </p>
        )}
      </div>
    </div>
  );
};

export default ThankYouScreen;